# GraphQL query to get all the emails for a given stage

#import "../fragments/sales-automation-step-template.graphql"

query GetStepTemplate($id: ID!) {
    stepTemplate(id: $id) {
        ...SalesAutomationStepTemplate
    }
}
